import template from './expenses.html';
import controller from './expenses.controller';

let expensesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default expensesComponent;



// WEBPACK FOOTER //
// ./client/pages/expenses/expenses.component.js